/* @flow */
import React, {
  useContext, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import { FAB, IconButton } from 'react-native-paper';
import { View } from 'react-native';
import LottieView from 'react-lottie';
import Button from '@material-ui/core/Button';

import useHotkey from '../hooks/useHotkey';
import l from '../utils/localization';
import { useColor, useColors } from '../contexts/theme';
import MultiSelectContext from '../contexts/MultiSelect';
import { navigateToItem } from '../modules/navigation/actions';
import OverlayContext from '../contexts/OverlayContext';


const lottieFiles = [
  // require('../../../../resources/lottie/5830-happy-blob-empty.json'),
  require('../resources/lottie/5819-celebration-karaoke.json'),
  require('../resources/lottie/5820-celebration-movies.json'),
  require('../resources/lottie/5821-celebration-music.json'),
  require('../resources/lottie/5822-celebration-selfie.json'),
  require('../resources/lottie/5823-celebration-superclean.json'),
  require('../resources/lottie/5824-celebration-videos.json'),
  // require('../../../../resources/lottie/5831-happy-blob-empty-sip-china.json'),
];


const styles = {
  wrapper: {
    position: 'fixed', height: '100%', width: '100%', zIndex: 999999, pointerEvents: 'none',
  },
  lottieContainer: {
    position: 'fixed', right: 0, left: 0, bottom: -10,
  },
  container: {
    position: 'fixed', top: 10, right: 10, zIndex: 9, pointerEvents: 'auto',
  },
  button: { marginTop: 6 },
  fab: { position: 'fixed', bottom: 40, right: 40 },
};

const MultiSelectToggleEnabled = () => {
  const primaryText = useColor('primaryText'),
        { toggleEnabled, isEnabled } = useContext(MultiSelectContext);

  return (
    <div style={styles.container} className='scaleOnFocus'>
      { isEnabled ? <Button onClick={toggleEnabled} style={{ color: primaryText, ...styles.button }}>{ l.cancel }</Button> : (
        <IconButton
          color={primaryText}
          className='scaleOnFocus'
          icon='format-list-bulleted'
          onPress={toggleEnabled}
        />
      ) }
    </div>
  );
};


const Lottie = ({ uniqueness = 1, isPaused }: Object) => {
  const lottieFile = lottieFiles[uniqueness
    ? uniqueness % lottieFiles.length
    : Math.floor(Math.random() * lottieFiles.length)];

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieFile,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <View style={[styles.lottieContainer, { opacity: isPaused ? 0 : 1 }]}>
      <LottieView
        options={defaultOptions}
        speed={0.1}
        isPaused={isPaused}
        height='50%'
        width='50%'
      />

    </View>
  );
};

const AddItemFAB = ({ style }: Object) => {
  const colors = useColors(),
        dispatch = useDispatch(),
        { newTaskTemplate } = useContext(OverlayContext);


  const onAdd = useCallback(() => {
    dispatch(navigateToItem(newTaskTemplate));
  }, [newTaskTemplate]); // eslint-disable-line


  useHotkey('+', () => {
    if (window.location.href.indexOf('itemId') === -1) {
      onAdd();
    }
  });

  return (
    <FAB
      color={colors.primaryText}
      icon='plus'
      testID='btnAdd'
      className='scaleOnFocus'
      onPress={onAdd}
      style={[
        style,
        {
          backgroundColor: colors.primary,
        },
      ]}
    />
  );
};


const Overlay = ({ showAnimation }: Object) => {
  const { hideAdd } = useContext(OverlayContext),
        { isEnabled } = useContext(MultiSelectContext);

  return (
    <div style={styles.wrapper}>
      <MultiSelectToggleEnabled />
      { !isEnabled && !hideAdd
        ? (<AddItemFAB style={styles.fab} />)
        : null }
      <Lottie isPaused={!showAnimation} />
    </div>
  );
};

export default Overlay;
